@if (required) {
  <div class="weaveFormField">
    @if (label && longTitle) {
      <div class="pageHeader" id="{{id}}">
        {{label}}<span class="required">*</span>
      </div>
    }
    <mat-form-field
      appearance="{{appearance}}"
      [class]="['fullWidth']"
      [hideRequiredMarker]="hideRequiredMarker"
    >
      @if (label && !longTitle) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        [class]="['weaveInput']"
        [type]="type"
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut(); onKeyUpEnter();"
        (focusout)="onFocusOut()"
        (paste)="onPaste($event)"
        (keyup)="onKeyUp($event)"
        (keydown)="onKeyDown($event)"
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        [email]="type === 'email'"
        [appRequireTld]="type === 'email'"
        required
        #inputElement
        [matAutocomplete]="auto"
        [formControl]="searchItemsCtrl"
      >
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelected($event)">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option.value">{{option.label}}</mat-option>
        }
      </mat-autocomplete>
      @if(searchItemsCtrl.invalid && searchItemsCtrl.touched) {

        <mat-error>
          @if (searchItemsCtrl.hasError('email') || searchItemsCtrl.hasError('missingTld')) {
            Invalid email
          }
          @else if (searchItemsCtrl.hasError('required')) {
            {{label || "This field"}} is required
          }
        </mat-error>
      }
      @if (showError && data === '' && required) {
        <div
          class="weaveFormField_error">
          {{label || "This field"}} cannot be empty
        </div>
      }
    </mat-form-field>
    @if (description) {
      <div class="applicationHTML" [innerHTML]="description"></div>
    }
  </div>
}
@if (!required) {
  <div class="weaveFormField">
    @if (label && longTitle) {
      <div class="pageHeader" id="{{id}}">
        {{label}}
      </div>
    }
    <mat-form-field appearance="outline" class="fullWidth">
      @if (label && !longTitle) { <mat-label>{{label}}</mat-label> }
      <input
        matInput
        class='weaveInput'
        [type]="type"
        [disabled]="disabledFlag"
        (keyup.enter)="onFocusOut(); onKeyUpEnter();"
        (keydown)="onKeyDown($event)"
        (paste)="onPaste($event)"
        (focusout)="onFocusOut()"
        (keyup)="onKeyUp($event)"
        (focusin)="startEdit()"
        (keydown.escape)="undo()"
        [placeholder]="placeholder"
        [maxlength]="maxlength"
        #inputElement
        [matAutocomplete]="auto"
        [formControl]="searchItemsCtrl"
      >
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelected($event)">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option.value">{{option.label}}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    @if (description) {
      <div class="applicationHTML" [innerHTML]="description"></div>
    }
  </div>
}
